import React from "react"
import FeaturedSpeakers from "../../../components/speakers/FeaturedSpeakers";
import {PagePanel} from "../../../components/helpers/PagePanel";
import {Link} from "react-router-dom";

export const Featured = (props) => (
    <PagePanel className="transparent featured" title="Featured speakers">

        <FeaturedSpeakers/>
        <div className="text-center lead">
            <Link to="/speakers">List all speakers</Link>
        </div>
    </PagePanel>
);


// WEBPACK FOOTER //
// ./src/pages/home/fragments/Featured.js